/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeriscope = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.128 14.942c-3.128 0-5.539-2.34-5.539-5.079 0-1.117.328-2.139.895-2.986.186.972 1.063 1.708 2.117 1.708 1.19 0 2.154-.936 2.154-2.091 0-.784-.445-1.467-1.102-1.825a5.969 5.969 0 0 1 1.475-.183c2.82 0 5.23 2.34 5.23 5.377 0 2.738-2.41 5.08-5.23 5.08M12.1 1C7.018 1 3 5.107 3 10.062c0 5.177 7.065 12.899 9.1 12.899 1.783 0 8.848-7.722 8.848-12.899C20.948 5.107 16.93 1 12.1 1"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPeriscope as Periscope };
